/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Component information specific to a DRC resource
 */
export interface DrcComponentInfo { 
    /**
     * OAuth application secret used for DRC integration
     */
    oAuthAppSecretCreation?: Date;
    /**
     * Timestamp when the OAuth application secret was created (epoch millis)
     */
    oAuthAppSecretCreationTs?: number;
    /**
     * OAuth application identifier
     */
    oAuthAppId?: string;
    /**
     * IP address of the DRC
     */
    ipAddress?: string;
    /**
     * Connector OS version
     */
    osVersion?: string;
    /**
     * Connector Container version
     */
    containerVersion?: string;
    /**
     * Identifier of the associated site
     */
    siteId?: string;
}

